<template>
  <div class="feedback" @click="createWaveSurfer()">
    <div class="user">
      <div class="image">
        <img src="../assets/IngoSchimpff.jpg" />
      </div>
    </div>
    <div class="offer">
      <div class="details">
        <div class="track-details">
          <span class="track-title">
            First Aim Cover
          </span>
          <span class="user-name">
            by Isak Johannesson
          </span>
        </div>
        <div class="offer-details">
          <span class="price">
            $200
          </span>
        </div>
      </div>
      <div class="track">
        <div class="player">
          <div class="controls">
            <div @click="wavesurfer.playPause()" class="play">
              <img src="../assets/icons/Track-Play.svg" />
            </div>
          </div>
          <div class="info">
            <span>{{ current }}</span>
          </div>
          <div class="waveform-container">
            <div id="waveform"></div>
            <div v-if="trackLoaded" class="comments">
              <div
                v-for="(c, i) in timeStampComments"
                :key="i"
                class="comment"
                :style="{ marginLeft: calculateDurationPercent(c.timeStamp) }"
              >
                <div class="image">
                  <img src="../assets/IngoSchimpff.jpg" />
                </div>
              </div>
              <!--              <div class="comment" style="margin-left: 25%;">-->
              <!--                <div class="image">-->
              <!--                  <img src="../assets/IngoSchimpff.jpg" />-->
              <!--                </div>-->
              <!--              </div>-->
              <!--              <div class="comment" style="margin-left: 70%;">-->
              <!--                <div class="image">-->
              <!--                  <img src="../assets/IngoSchimpff.jpg" />-->
              <!--                </div>-->
              <!--              </div>-->
              <!--              <div class="comment" style="margin-left: 80%;">-->
              <!--                <div class="image">-->
              <!--                  <img src="../assets/IngoSchimpff.jpg" />-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
          <div class="info">
            <span>{{ duration }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="input">
      <div class="texta">
        <textarea
          v-model="comment"
          placeholder="Click on the track to comment on a specific part"
        ></textarea>
        <div class="buttons">
          <div @click="toggleCommentType()" class="commentime">
            <div v-if="!isGeneralComment" class="icon">
              <div class="icon-fill"></div>
            </div>
            <div class="time">
              <span>{{ commentTypeText }}</span>
            </div>
          </div>
          <button
            @click="addComment()"
            :disabled="disableAddCommentButton"
            class="send"
          >
            <ArrowRightIcon :accent="false" />
          </button>
        </div>
      </div>
    </div>
    <div class="input-hint">
      <span>{{ requiredCharCount }} more characters required</span>
    </div>
    <div class="comments">
      <div v-for="(c, i) in sortedComments" :key="i" class="comment">
        <div class="image">
          <img src="../assets/IngoSchimpff.jpg" />
        </div>
        <div class="details">
          <div class="user-name">Chin Sarasvati</div>
          <div class="comment-details">
            <div class="timestamp">
              <span>{{ createCommentTypeText(c.timeStamp) }}</span>
            </div>
            <div class="text">
              <span>{{ c.comment }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="primary">
          I’m done commenting
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import ArrowRightIcon from "@/assets/icons/Arrow-right.vue";
export default {
  data() {
    return {
      id: "",
      wavesurfer: null,
      track:
        "https://archive.org/download/cd_hypnotize_system-of-a-down_1/disc1/04.%20System%20Of%20A%20Down%20-%20Hypnotize_sample.mp3",
      currentSeconds: 0,
      durationSeconds: null,
      trackLoaded: false,
      isGeneralComment: true,
      comment: "",
      comments: [
        {
          comment:
            "You’ve got some talented pipes, but the vocals were sometimes drown out by the sound of the cicadas.",
          timeStamp: null
        },
        {
          comment:
            "I love what you did with the snare drums here, but the transition needs work. Introduce a macarena or two.",
          timeStamp: 23
        },
        {
          comment:
            "If I could have this as my ringtone, I would. Make this the chorus and throw it in again at the 1:07 mark.",
          timeStamp: 48
        },
        {
          comment:
            "Ahhhh, the xylophone really sells it here. I say extend this part. More xylophone!",
          timeStamp: 168
        }
      ]
    };
  },
  async mounted() {
    if (!this.wavesurfer) this.createWaveSurfer();
  },
  name: "TrackFeedback",
  components: {
    ArrowRightIcon
  },
  computed: {
    waveformId() {
      return `waveform${this.id}`;
    },
    current: function() {
      if (this.trackLoaded) {
        return this.calculateDuration(this.currentSeconds);
      }
      return "0:00";
    },
    duration: function() {
      if (this.trackLoaded) {
        return this.calculateDuration(this.durationSeconds);
      }
      return "0:30";
    },
    commentTypeText() {
      if (this.isGeneralComment) {
        return "general";
      } else {
        return this.current;
      }
    },
    sortedComments() {
      return [...this.comments].sort((a, b) =>
        a.timeStamp > b.timeStamp ? 1 : -1
      );
    },
    timeStampComments() {
      return this.sortedComments.filter(x => x.timeStamp);
    },
    requiredCharCount() {
      if (this.comment.length < 120) {
        return 120 - this.comment.length;
      } else {
        return 0;
      }
    },
    disableAddCommentButton() {
      return this.requiredCharCount > 0;
    }
  },
  methods: {
    calculateDuration(seconds) {
      let sec = (seconds % 60).toFixed(0);
      const min = Math.floor(seconds / 60).toFixed(0);
      if (sec.toString().length === 1) {
        sec = "0" + sec;
      }
      return min + ":" + sec;
    },
    calculateDurationPercent(seconds) {
      const percent = (seconds / this.durationSeconds) * 100;
      return `calc( ${percent}% - 9px )`;
    },
    createWaveSurfer() {
      if (this.wavesurfer) return;
      this.id = Date.now();
      this.wavesurfer = WaveSurfer.create({
        // container: `#waveform${this.Id}`,
        container: `#waveform`,
        waveColor: "#EDEDED",
        progressColor: "#FF035A",
        cursorColor: "#3B3B3B",
        barHeight: 1,
        barMinHeight: 1,
        barWidth: 3,
        barRadius: 3,
        cursorWidth: 1,
        height: 40,
        barGap: 3
      });
      this.wavesurfer.load(this.track);

      this.wavesurfer.on("ready", () => {
        this.trackLoaded = true;
        this.durationSeconds = this.wavesurfer.getDuration();
      });

      this.wavesurfer.on("audioprocess", () => {
        this.currentSeconds = this.wavesurfer.getCurrentTime();
      });

      this.wavesurfer.on("seek", () => {
        this.isGeneralComment = false;
      });
    },
    toggleCommentType() {
      this.isGeneralComment = !this.isGeneralComment;
    },
    createCommentTypeText(timestamp) {
      if (timestamp) {
        return this.calculateDuration(timestamp);
      } else {
        return "General";
      }
    },
    addComment() {
      const comment = {
        comment: this.comment,
        timeStamp: this.currentSeconds
      };
      if (this.isGeneralComment) {
        comment.timeStamp = null;
      }
      this.comments.push(comment);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_mixins.scss";
.feedback {
  display: flex;
  background: $bg;
  margin-bottom: 40px;
  flex-wrap: wrap;
  .user {
    display: flex;
    flex-direction: column;
    align-items: center;
    .image {
      width: 108px;
      height: 108px;
      overflow: hidden;
      border-radius: 50%;
      img {
        object-fit: cover;
      }
    }
  }
  .offer {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    .details {
      width: 100%;
      display: flex;
      .track-details {
        display: flex;
        flex-direction: column;
        flex: 1;
        .track-title {
          @include menu-bold();
        }
        .user-name {
          @include body-light(16px, 24px);
          color: $text-additional;
          margin-top: 8px;
        }
      }
      .offer-details {
        @include body-light();
        .price {
          font-weight: 700;
          color: $accent;
        }
      }
    }
    .track {
      width: 100%;
      margin-top: 16px;
      .player {
        display: flex;
        align-items: baseline;
        .controls {
          width: 38px;
          margin-right: 8px;
          .play {
            img {
              width: 38px;
              height: 38px;
            }
          }
        }
        .info {
          width: 24px;
          span {
            font-size: 12px;
            line-height: 14px;
            letter-spacing: -0.165px;
            color: $text-additional;
          }
        }
        .waveform-container {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          #waveform {
            width: 100%;
            margin: 0 16px;
            height: 40px;
            overflow-y: hidden;
          }
          .comments {
            display: flex;
            width: 100%;
            margin: 4px 16px 0;
            position: relative;
            .comment {
              display: flex;
              flex-direction: column;
              align-items: center;
              position: absolute;
              .image {
                width: 18px;
                height: 18px;
                overflow: hidden;
                border-radius: 50%;
                img {
                  object-fit: cover;
                }
              }
            }
          }
        }
      }
    }
  }
  .input {
    width: 100%;
    height: 180px;
    padding: 16px;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 5px;
    margin-top: 32px;
    .texta {
      height: 148px;
      // border-top: 1px solid #e0e0e0;
      display: flex;
      flex-direction: column;
      textarea {
        height: 109px;
        // padding: 24px 0;
        border: none;
        background: transparent;
        resize: none;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: -0.22px;
        color: $text-additional;
        &:focus {
          outline: none;
        }
      }
      .buttons {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        button {
          &:focus {
            outline: none;
          }
        }
        .commentime {
          background: #ececec;
          border-radius: 5.5px;
          display: flex;
          align-items: center;
          padding: 2px 8px 2px 8px;
          cursor: pointer;
          .icon {
            width: 11px;
            height: 11px;
            background: white;
            border: 1px solid $text;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 6px;
            .icon-fill {
              width: 7px;
              height: 7px;
              border-radius: 50%;
              background: $text;
            }
          }
          .time {
            display: flex;
            align-items: center;
            padding-bottom: 1px;
            span {
              font-size: 16px;
              line-height: 19px;
              letter-spacing: -0.22px;
              color: $text;
            }
          }
        }
        .send {
          width: 38px;
          height: 38px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: none;
          background: $accent;
          border-radius: 50%;
          cursor: pointer;
        }
      }
    }
  }
  .input-hint {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.22px;
    color: $text-additional;
  }
  .comments {
    margin-top: 32px;
    width: 100%;
    .comment {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      .image {
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 50%;
        img {
          object-fit: cover;
        }
      }
      .details {
        margin-left: 16px;
        .user-name {
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          display: flex;
          align-items: center;
          letter-spacing: -0.22px;
          color: $text;
        }
        .comment-details {
          display: flex;
          //   margin-top: 8px;
          align-items: baseline;
          .timestamp {
            background: #ececec;
            border-radius: 5.5px;
            padding: 0 6px;
            height: 17px;
            display: flex;
            align-items: center;
            span {
              font-weight: 300;
              font-size: 13px;
              line-height: 13px;
              letter-spacing: -0.22px;
              color: $text-additional;
            }
          }
          .text {
            margin-left: 8px;
            font-weight: 300;
            font-size: 16px;
            line-height: 24px;
            display: flex;
            align-items: center;
            letter-spacing: -0.22px;
            color: $text;
          }
        }
      }
    }
    .buttons {
      width: 100%;
      display: flex;
      justify-content: center;
      button {
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        letter-spacing: -0.22px;
      }
    }
  }
}
</style>
